// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the bullethead's stocks open at,
// NOAA's density and mean length of the fish the fishery takes (Nadon 2017), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/bullethead.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const BULLETHEAD_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 3576.59,
  fishingPerYear: 0.129747,
  restSpawnersKg: 89564.5,
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const BULLETHEAD_JANUARY: FishJanuary = {
  islands: [
    [0, 0, 854473, 550071, 265730, 136358, 64692.4, 35668.2, 0, 0, 0, 0, 0, 0, 8995.71, 10132.8, 8420.13, 7578.39, 6001.47, 5113.47, 0, 0, 0, 0, 0, 0, 2543.04, 3134.04, 2851.61, 2789.59, 2396.99, 2208.47, 0, 0, 0, 0, 0, 0, 1391.26, 1704.57, 1544.42, 1506.56, 1292.22, 1189.28, 0, 0, 0, 0, 0, 0, 747.984, 916.409, 830.294, 809.935, 694.697, 639.356, 0, 0, 0, 0, 0, 0, 402.111, 492.655, 446.36, 435.415, 373.464, 343.713, 0, 0, 0, 0, 0, 0, 216.171, 264.847, 239.959, 234.075, 200.771, 184.777, 0, 0, 0, 0, 0, 0, 116.211, 142.379, 129, 125.837, 107.933, 99.3342, 0, 0, 0, 0, 0, 0, 62.474, 76.5414, 69.3488, 67.6484, 58.0234, 53.4009, 0, 0, 0, 0, 0, 0, 33.5864, 41.1491, 37.2822, 36.368, 31.1936, 28.7084, 0, 0, 0, 0, 0, 0, 18.0558, 22.1215, 20.0426, 19.5512, 16.7695, 15.4333, 0, 0, 0, 0, 130.178],
    [0, 0, 1123960, 761783, 379004, 193284, 97802.1, 51203.8, 0, 0, 0, 0, 0, 0, 11743.6, 13952.1, 11961.5, 10718.7, 9066.04, 7336.56, 0, 0, 0, 0, 0, 0, 3323.09, 4317.04, 4046.42, 3939.36, 3616.35, 3165.44, 0, 0, 0, 0, 0, 0, 1818.02, 2348, 2191.52, 2127.51, 1949.57, 1704.62, 0, 0, 0, 0, 0, 0, 977.419, 1262.32, 1178.18, 1143.76, 1048.09, 916.402, 0, 0, 0, 0, 0, 0, 525.454, 678.616, 633.383, 614.876, 563.446, 492.651, 0, 0, 0, 0, 0, 0, 282.479, 364.818, 340.501, 330.552, 302.903, 264.845, 0, 0, 0, 0, 0, 0, 151.857, 196.122, 183.05, 177.701, 162.838, 142.378, 0, 0, 0, 0, 0, 0, 81.6365, 105.433, 98.4052, 95.5302, 87.5399, 76.5404, 0, 0, 0, 0, 0, 0, 43.8881, 56.6812, 52.9031, 51.3575, 47.0618, 41.1483, 0, 0, 0, 0, 0, 0, 23.593, 30.4709, 28.4399, 27.6092, 25.3, 22.1205, 0, 0, 0, 0, 183.151],
    [0, 0, 418078, 269619, 136922, 68506.8, 32835.2, 18245.9, 0, 0, 0, 0, 0, 0, 4443.66, 5002.86, 4360.62, 3817.85, 3048.2, 2615.55, 0, 0, 0, 0, 0, 0, 1254.52, 1545.41, 1477.24, 1408.14, 1219.43, 1131.06, 0, 0, 0, 0, 0, 0, 686.328, 840.532, 800.067, 760.488, 657.393, 609.09, 0, 0, 0, 0, 0, 0, 368.99, 451.885, 430.123, 408.841, 353.415, 327.445, 0, 0, 0, 0, 0, 0, 198.367, 242.93, 231.231, 219.79, 189.993, 176.032, 0, 0, 0, 0, 0, 0, 106.64, 130.597, 124.308, 118.157, 102.139, 94.6332, 0, 0, 0, 0, 0, 0, 57.3287, 70.2077, 66.8267, 63.5201, 54.9087, 50.8739, 0, 0, 0, 0, 0, 0, 30.8193, 37.7429, 35.9253, 34.1477, 29.5183, 27.3492, 0, 0, 0, 0, 0, 0, 16.5686, 20.2908, 19.3136, 18.358, 15.8692, 14.7031, 0, 0, 0, 0, 0, 0, 8.90725, 10.9083, 10.383, 9.86926, 8.53127, 7.90433, 0, 0, 0, 0, 65.6881],
    [0, 0, 56081.6, 36662.4, 18432.3, 9358.66, 4428.95, 2357.67, 0, 0, 0, 0, 0, 0, 614.759, 696.458, 596.681, 526.155, 411.983, 338.009, 0, 0, 0, 0, 0, 0, 172.804, 214.179, 202.417, 195.311, 165.677, 146.765, 0, 0, 0, 0, 0, 0, 94.5386, 116.49, 109.628, 105.481, 89.3167, 79.0346, 0, 0, 0, 0, 0, 0, 50.8268, 62.6271, 58.9371, 56.7069, 48.0166, 42.4888, 0, 0, 0, 0, 0, 0, 27.3241, 33.6678, 31.6841, 30.4852, 25.8134, 22.8416, 0, 0, 0, 0, 0, 0, 14.6892, 18.0995, 17.0331, 16.3886, 13.877, 12.2795, 0, 0, 0, 0, 0, 0, 7.89678, 9.73015, 9.15685, 8.81036, 7.46018, 6.60134, 0, 0, 0, 0, 0, 0, 4.24524, 5.23084, 4.92264, 4.73637, 4.01052, 3.54882, 0, 0, 0, 0, 0, 0, 2.28227, 2.81213, 2.64644, 2.5463, 2.15607, 1.90786, 0, 0, 0, 0, 0, 0, 1.22696, 1.51181, 1.42273, 1.3689, 1.15911, 1.02567, 0, 0, 0, 0, 8.96908],
  ],
  afloat: [
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ],
};
